<template>
  <transition name="slide" :duration="duration">
    <div v-show="show" class="modal-container">
      <div class="modal">
        <div class="modal-dialog" :class="'modal-xl'">
          <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
              <div class="modal-title">
                <div>Upload User Portfolio File</div>
              </div>
            </div>
            <!--Container-->
            <div class="modal-body">
              <div class="form-group">
                <form enctype="multipart/form-data" novalidate>
                  <p>Upload pdf/images</p>
                  <div class="dropbox">
                    <input type="file" :name="uploadFieldName" :disabled="isSaving"
                      @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                      accept="image/*, application/pdf" class="input-file">
                    <p v-if="isInitial">
                      Drag your file(s) here to begin<br> or click to browse
                    </p>
                    <p v-if="isSaving">
                      Uploading {{ fileCount }} files...
                    </p>
                  </div>
                  <div style="padding-top: 15px;">
                    <label>
                      <input type="radio" value="CDSL" v-model="selectedType"> CDSL
                    </label>
                    <label>
                      <input type="radio" value="NSDL" v-model="selectedType"> NSDL
                    </label>
                  </div>
                </form>
                <!-- <form @submit.prevent='' enctype="multipart/form-data">
                  <div class="form-group ">

                    <div class="upload-file1 ">
                      <input id='file' name='csvfile' type="file" @change='filesChange($event)'>
                      <submitButton @click='importCsv' class=" btn btn-primary">Import</submitButton>
                    </div>
                    <p class="small">
                      To download sample csv format <a :href="link" style='color:blue;font-size:1.2em'>click here</a>
                    </p>

                  </div>

                </form> -->
              </div>
            </div>
            <!--Footer-->
            <div class="modal-footer">
              <button type="button" class="mt-3" :class="'btn btn-primary'" @click="save">Upload</button>
              <button type="button" class="mt-3" :class="'btn btn-secondary'" @click="cancel"
                data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop"></div>
    </div>
  </transition>
</template>
<script>
import http from "@/lib/http";
const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
//var Validator = SimpleVueValidation.Validator;
export default {
  name: "UploadFile",
  props: {
    transition: {
      type: String,
      default: "modal"
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: "CONFIRM"
    },
    cancelText: {
      type: String,
      default: "CANCEL"
    },
    okClass: {
      type: String,
      default: "btn btn-primary"
    },
    cancelClass: {
      type: String,
      default: "btn btn-secondary"
    },
    user: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
      duration: 200,
      pin: "",
      error: "",
      submitted: false,
      currentStatus: null,
      uploadedDocFile: null,
      uploadError: null,
      uploadFieldName: 'userDocuments',
      selectedType: "NSDL",
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy() {
    /* document.body.className = document.body.className.replace(
      /\s?modal-open/,
      ""
    ); */
  },
  watch: {
    /* show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(
            /\s?modal-open/,
            ""
          );
        }, this.duration);
      }
    }, */
    user(value) {
      this.userid = value;
    }
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedDocFile = null;
      this.uploadError = null;
    },
    ok() {
      // console.log("PIN", this.pin);
      // var j = VueJwtDecode.decode(localStorage.getItem("token"));
      // console.log("Token decoded", j);
      // this.$emit("submitPin", { pin: this.pin, user: j.id });
      this.submitted = true;
      /* this.$validate().then(success => {
        // console.log('on success ' + success)
        if (success) {
          this.validatePin({ pin: this.pin, user: this.userid });
        }
      }); */
      //this.show = false
    },
    cancel() {
      this.$emit("cancel");
      this.uploadedDocFile = null;
      this.show = false;
    },
    save() {
      let _this = this;
      // upload data to the server
      console.log('uploadedDocFile:', _this.uploadedDocFile);
      if (_this.uploadedDocFile === null) {
        this.$toastr.error("Please upload document.", "", {});
        return;
      }

      if (_this.uploadedDocFile.get("file_type") === "pdf") {
        _this.uploadedDocFile.set("pdf_type", _this.selectedType);
      }

      this.submitted = true;
      this.show = false;
      //return;
      _this.currentStatus = STATUS_SAVING;
      //frontend/insertStockDetailsFromDocuments
      //gemini/frontend/insertStockDetailsFromDocuments

      http.post("gemini/frontend/insertStockDetailsFromDocuments", _this.uploadedDocFile, (error, response) => {
        console.log('### response::: ', response);
        this.$toastr.success(response.success, "", {});
        _this.currentStatus = STATUS_SUCCESS;
        _this.uploadedDocFile = null;
      });
      /* upload(formData)
        .then(wait(1500)) // DEV ONLY: wait for 1.5s 
        .then(x => {
          this.uploadedDocFile = [].concat(x);
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch(err => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        }); */
    },
    filesChange(fieldName, fileList) {
      console.log('=> fieldName', fieldName);
      console.log('=> fileList', fileList);
      console.log('=> user', this.user, this.userid);
      // handle file changes
      if (!fileList.length) return;
      console.log('fileList[0]=>', fileList[0]);
      let curFile = fileList[0];

      let type = curFile.type;// fileList[0].type === "application/pdf" ? "pdf" : fileList[0].type === "image/jpeg" ;
      let fType = "";

      if (type.indexOf("image") !== -1) {
        fType = "image";
      }
      if (type.indexOf("pdf") !== -1) {
        fType = "pdf";
      }

      const formData = new FormData();
      formData.append("userid", this.user);
      formData.append("file_type", fType);
      if (fType === "pdf") {
        formData.append("pdf_type", this.selectedType);
      }
      formData.append("file", curFile);

      console.log("formData:::", formData.getAll("userid"), formData.getAll("file_type"), formData.getAll("file"));
      this.uploadedDocFile = formData;
      // append the files to FormData
      /* Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name);
        }); */

      // save it
      //this.save(formData);
    },
    clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open() {
      this.show = true;
    },
    /* validatePin(pin) {
      this.error = "";
      var _this = this;
      console.log("pin entered", pin);
      http.post(
        "user/changePIN/" + pin.user,
        { pin: pin.pin },
        (error, response) => {
          console.log("submitted pin", response);
          if (response.responseType === "success") {
            _this.error = "";
            _this.submitted = false;
            _this.show = false;
            _this.$toastr.success(response.message, "", {});
            // _this.$emit("submitForm");
          } else {
            _this.error = response.message;
          }
        }
      );
    } */
  }
};
</script>
<style lang="scss">
span.error {
  color: #dc3545;
}

// For Transitioning
.slide-enter-active {
  animation: slide-in 3s fade forwards;
}

.slide-leave-active {
  animation: slide-out 3s fade forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(250px);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(250px);
  }
}

.modal {
  display: block;
}

.modal-dialog,
.modal-backdrop {
  transition: all 0.5s ease;
}

.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  opacity: 0;
  transform: translateY(-30%);
}

.modal-enter .modal-backdrop,
.modal-leave-active .modal-backdrop {
  opacity: 0;
}

.modal-backdrop {
  opacity: 0.5;
}

//Modal styles

.modal-header {
  height: 55px;
  padding: 0 1.6rem;
  border-bottom: 2px solid #eee;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}

.modal-content {
  border-radius: 0;
}

.modal-footer {
  justify-content: center;
  padding: 0 2px;
  padding-bottom: 5px;
  flex-wrap: wrap;

  .btn {
    margin: 0 10px 20px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UploadFile.vue